const memoizeDndCollect = <M, V extends Record<string, unknown>>(
  collect: (monitor: M) => V,
) => {
  let values: V | null = null;

  return (monitor: M) => {
    const newValues = collect(monitor);

    if (
      !values ||
      Object.entries(newValues).some(([k, v]) => values?.[k] !== v)
    ) {
      values = newValues;
    }

    return values;
  };
};

export default memoizeDndCollect;
